export interface BuildConflictView {
  operationId: string;
  paths: string[];
  versions: Array<{ path: string; current: string | null; built: string | null; binary?: boolean; truncated?: boolean }>;
}

export function BuildConflictDescription({ conflict }: { conflict: BuildConflictView }) {
  return <div className="space-y-3">
    <p>Built files come from your saved source. Current files preserve edits made elsewhere. Nothing is published until this choice is resolved.</p>
    <div className="max-h-80 space-y-3 overflow-y-auto rounded-md border p-3">
      {conflict.versions.map(version => <div key={version.path} className="space-y-1">
        <p className="break-all font-medium text-foreground">{version.path}</p>
        {version.binary ? <p>Binary content cannot be shown here. Choose which version to keep.</p> : <div className="grid min-w-0 gap-2 sm:grid-cols-2">
          <div className="min-w-0"><p className="text-xs font-medium">Current file</p><pre className="max-h-40 overflow-auto whitespace-pre-wrap break-all rounded bg-muted p-2 text-xs">{version.current ?? 'File is absent'}</pre></div>
          <div className="min-w-0"><p className="text-xs font-medium">Built file</p><pre className="max-h-40 overflow-auto whitespace-pre-wrap break-all rounded bg-muted p-2 text-xs">{version.built ?? 'File is absent'}</pre></div>
        </div>}
        {version.truncated && <p className="text-xs">Long file contents are shortened in this review.</p>}
      </div>)}
      {conflict.paths.length > conflict.versions.length && <p className="break-all">{conflict.paths.length - conflict.versions.length} additional affected files: {conflict.paths.filter(path => !conflict.versions.some(version => version.path === path)).join(', ')}</p>}
    </div>
    <p>Keep current files is selected to preserve existing edits. Clear the checkbox to use the built files instead.</p>
  </div>;
}
